import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7dc922"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button__background" }, null, -1))
const _hoisted_2 = { class: "button__label_container" }
const _hoisted_3 = { class: "button__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.elementType), {
    href: _ctx.elementType === 'a' ? _ctx.href : null,
    class: _normalizeClass(["button", [
      `button--${_ctx.color}`,
      _ctx.fontweight !== 'bold' ? `button--${_ctx.fontweight}` : '',
    ]]),
    target: _ctx.target ? _ctx.target : null,
    ref: "button",
    onMouseenter: _ctx.hover,
    onMouseleave: _ctx.hoverOff
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                type: _ctx.icon,
                class: _normalizeClass(`button__icon button__icon--${_ctx.icon}`)
              }, null, 8, ["type", "class"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
          _createVNode(_component_Icon, {
            type: "arrow-right",
            class: "button__arrow"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["href", "class", "target", "onMouseenter", "onMouseleave"]))
}